import React from 'react'
import styled from 'styled-components'

const WrapVideo = styled.div`
  position: relative;
  overflow: hidden;
  padding-top: 70vh;
  .wrapvideo {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`

const VideoPage = ({ data }) => {
  console.log('data inside', data)

  const {
    asignatura,
    curso,
    descripcion,
    id,
    nombre,
    profesor,
    rudoid,
    videoid,
  } = data
  return (
    <div>
      <div className="bg-black">
        <WrapVideo>
          <iframe
            title={nombre}
            className="wrapvideo"
            src={`https://rudo.video/vod/${rudoid}?stv=0`}
            allowscriptaccess="always"
            allowfullscreen="true"
            webkitallowfullscreen="true"
            frameborder="0"
            scrolling="no"
            allow="autoplay; fullscreen"></iframe>
        </WrapVideo>
      </div>
      <div className="info sm:px-16 p-4 mx-auto">
        <div>
          <h2 className="leading-none">{nombre}</h2>
          <h3 className="font-sans text-gray-700 text-xl mb-4 ">{profesor}</h3>
          <p
            className=" leading-tight "
            dangerouslySetInnerHTML={{ __html: descripcion }}></p>
        </div>
      </div>
    </div>
  )
}

export default VideoPage

{
  /* <iframe id="vrudo" class="vrudo" src="//rudo.video/vod/bK9GY2" width="560" height="315" allowscriptaccess="always" allowfullscreen="true" webkitallowfullscreen="true" frameborder="0" scrolling="no" allow="autoplay; fullscreen" ></iframe> */
}
